import { render } from "./UnSuccessfulModal.vue?vue&type=template&id=40f7a492&ts=true"
import script from "./UnSuccessfulModal.vue?vue&type=script&lang=ts"
export * from "./UnSuccessfulModal.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__